import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/integrations/axios/axios-instance'
import { API_PATH } from '@/constants/api'

export interface AddressPrediction {
  place_id: string
  description: string
  main_text: string
  secondary_text: string
}

export interface GoogleMapsAddress {
  place_id: string
  display_name: string
  address: {
    house_number?: string
    road?: string
    city?: string
    town?: string
    village?: string
    state?: string
    province?: string
    postcode?: string
    country?: string
  }
}

export const useAddressSearch = (searchTerm: string) => {
  return useQuery({
    queryKey: ['address-search', searchTerm],
    queryFn: async (): Promise<Array<AddressPrediction>> => {
      if (!searchTerm || searchTerm.length < 5) return []

      const response = await axiosInstance.get(
        `${API_PATH}/address/autocomplete`,
        {
          params: { input: searchTerm },
        },
      )

      return response.data
    },
    enabled: searchTerm.length >= 5,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}

export const useAddressDetails = (placeId: string | null) => {
  return useQuery({
    queryKey: ['address-details', placeId],
    queryFn: async (): Promise<GoogleMapsAddress> => {
      const response = await axiosInstance.get(
        `${API_PATH}/address/details/${placeId}`,
      )
      return response.data
    },
    enabled: !!placeId,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  })
}
